import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import {
	HeaderLogo,
	HeaderMenuToggleButton,
	HeaderSpecialLinks,
	HeaderTop,
} from "../components";
import HeaderFailedLoginsCheckButton from "../components/HeaderFailedLoginsCheckButton";
import HeaderUserBalance from "../components/HeaderUserBalance";
import HeaderAuthenticationButtons from "../components/HeaderAuthenticationButtons";

import { Button } from "@components/buttons";
import { MobilePlatform } from "@state/stores/types";
import CasinoHeaderSearch from "../components/CasinoHeaderSearch";

export default observer(function CasinoMainPageSearchHeader() {
	const {
		userAuthStore: { isLoggedIn },
		casinoSearchStore,
	} = useRootAppStore<MobilePlatform>();

	return (
		<header className="l--header l__header">
			<div className="header header--root">
				<div className="header__top">
					<HeaderTop />

					<HeaderSpecialLinks />
				</div>

				{!casinoSearchStore.isSearchOpen && (
					<div className="header__main header--root__main">
						<HeaderLogo />

						<nav className="header__nav">
							{isLoggedIn ? (
								<>
									{THEME_SETTINGS.failedLoginReport
										.isEnabled && (
										<HeaderFailedLoginsCheckButton />
									)}
									<HeaderUserBalance />
								</>
							) : (
								<HeaderAuthenticationButtons />
							)}

							<div className="header__actions">
								<Button
									type="button"
									onClick={() => {
										casinoSearchStore.searchButtonOnClick();
									}}
									atClassName="headerBtn--Search-Toggle"
									className="btn--square btn--square--sml btn--ghost"
									iconOnly
									iconClassName="u-icon--sml u-icon--search--reg u-color--core--snow"
								/>

								<HeaderMenuToggleButton />
							</div>
						</nav>
					</div>
				)}

				<CasinoHeaderSearch />
			</div>

			<div id="account24HourLockPopup" />
		</header>
	);
});
